import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const subs = new Set();

export const refreshAppConfig = () => api.get("/app-config").then(({ data }) => { cache = data; subs.forEach((f) => f(data)); }).catch(() => {});

export function useAppConfig() {
  const [cfg, setCfg] = useState(cache || {});
  useEffect(() => {
    subs.add(setCfg);
    if (!cache) refreshAppConfig();
    return () => subs.delete(setCfg);
  }, []);
  return cfg;
}
